export type PrizmAutoResizeMode = 'both' | 'only-increase';
// Event name when trigger resize func
export type PrizmAutoResizeOn = 'any' | 'input';
